import Vue from 'vue';

const state = Vue.observable({
  current: null,
});

let hideTimer = null;
let toastId = 0;

function clearTimer() {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
}

function normalizeType(type) {
  const value = String(type || 'info').toLowerCase();
  if (['success', 'error', 'warning', 'info'].includes(value)) return value;
  return 'info';
}

function show(message, type = 'info', duration = 4000) {
  if (!message) return;

  clearTimer();
  toastId += 1;
  state.current = {
    id: toastId,
    message: String(message),
    type: normalizeType(type),
  };

  if (duration > 0) {
    const activeId = toastId;
    hideTimer = setTimeout(() => {
      if (state.current && state.current.id === activeId) {
        state.current = null;
      }
      hideTimer = null;
    }, duration);
  }
}

function clear() {
  clearTimer();
  state.current = null;
}

export default {
  state,
  show,
  clear,
  success(message, duration = 4000) {
    show(message, 'success', duration);
  },
  error(message, duration = 4500) {
    show(message, 'error', duration);
  },
  warning(message, duration = 4500) {
    show(message, 'warning', duration);
  },
  info(message, duration = 4000) {
    show(message, 'info', duration);
  },
};
